import Home from "../Home/Home";
import Footer from "../Footer/Footer";
function App() {
    return (
        <div className="app-container">
            <Home />
            <Footer />
        </div>
    );
}
export default App;